// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"e6deda83","container":"b7400cce","removeTopPadding":"e1624bfb","removeBottomPadding":"c361dfbb","title":"dc6328cf","titleLarge":"d3c6583d","contentHtml":"d0d66eed"};